import PropTypes from 'prop-types';
import React from 'react';
import thumbnailPic from '../../../../../../static/images/images_placeholder.svg';
import iconPdf from '../../../../../../static/icons/icon-pdf.png';
import modifyImageLink from '../../../../../utils/modifyImageLink';
import { imageModifierTypes } from '../../../../../constants';
import styles from './CellGallery.scss';

export default class CellGalleryImage extends React.Component {
  handleClick = (evt) => evt.stopPropagation();

  render() {
    const { item } = this.props;

    if (item.raw) {
      return (
        <div className={styles.raw} key={item.thumbnail}>
          <img alt="" src={iconPdf} />
          <a href={item.thumbnail} onClick={this.handleClick}>
            {item.name}
          </a>
        </div>
      );
    }

    const desktopImage = encodeURI(modifyImageLink(
        item.thumbnail,
        imageModifierTypes.GALLERY_THUMBNAIL
      ));

    const mobileImage = encodeURI(modifyImageLink(
        item.thumbnail,
        imageModifierTypes.GALLERY_THUMBNAIL_MOBILE
      ));

    return (
      <div className={styles.image} key={item.thumbnail}>
        <img
          alt=""
          srcSet={`
            ${desktopImage || thumbnailPic} 350w,
            ${mobileImage || thumbnailPic} 600w
          `}
          sizes="(max-width: 767px) 600px, (min-width: 768px) 350px"
          src={desktopImage || thumbnailPic}
        />
      </div>
    );
  }
}

CellGalleryImage.propTypes = {
  item: PropTypes.object
};
